import React, { Component } from 'react';
import TranslatedCopy from '../../../../intl/translated-copy';
import Pictogram from '../../pictogram';

class AmaiaWelcome extends Component {
  render() {
    const { amaiaFaqChips, isAIResponding, onChipClick, userFirstName } = this.props;
    const mainChips = amaiaFaqChips.slice(0, 3);
    const secondaryChips = amaiaFaqChips.slice(3);

    return (
      <div className='AmaiaChat-main-content'>
        <div className='AmaiaChat-avatar-wrapper'>
          <div className='AmaiaChat-glow AmaiaChat-glow--cyan' />
          <div className='AmaiaChat-glow AmaiaChat-glow--magenta' />
          <div className='AmaiaChat-glow AmaiaChat-glow--blue' />
          <Pictogram
            className='AmaiaChat-logo-welcome'
            id='AmaiaLogoWelcome'
          />
        </div>
        <TranslatedCopy
          className='AmaiaChat-greeting'
          copyID='AMAIA_HELLO_I_AM_AMAIA'
          name={ userFirstName || '' }
          tagName='h2'
        />
        <TranslatedCopy
          className='AmaiaChat-greeting'
          copyID='AMAIA_I_AM_HERE_TO_HELP'
          name={ userFirstName || '' }
          tagName='h2'
        />
        <TranslatedCopy
          className='AmaiaChat-instruction'
          copyID='AMAIA_SELECT_AN_OPTION'
          name={ userFirstName || '' }
          tagName='p'
        />
        { amaiaFaqChips.length > 0 && (
          <div className='AmaiaChat-chips'>
            { mainChips.map((chip, index) => (
              <button
                className='AmaiaChat-chip'
                disabled={ isAIResponding }
                key={ index }
                onClick={ () => onChipClick(this.getChipText(chip)) }
              >
                { this.getChipText(chip) }
              </button>
            )) }
            { secondaryChips.map((chip, index) => (
              <button
                className='AmaiaChat-chip'
                disabled={ isAIResponding }
                key={ index }
                onClick={ () => onChipClick(this.getChipText(chip)) }
              >
                { this.getChipText(chip) }
              </button>
            )) }
          </div>
        ) }
      </div>
    );
  }

  getChipText = (chip) => {
    if (!chip) return '';
    if (typeof chip === 'string') return chip;
    return chip.text || chip.question || chip.label || chip.title || '';
  }
}

export default AmaiaWelcome;
